/*
 * Example, for usage as an XOR:
 *
   {
     adId: customPropType.exactlyOneOfType({
       types: [
         PropTypes.string.isRequired,
         customPropType.alternate('adUrl', PropTypes.any.isRequired),
       ],
       noMatchmessage: 'At least one of `adId` or `adUrl` has to be set'
       tooManyMessage: 'Whoops, has to be a string OR adUrl has to be set, but not both!'
     })
   }
 */
export var exactlyOneOfType = function exactlyOneOfType(_ref) {
  var types = _ref.types,
      noMatchMessage = _ref.noMatchMessage,
      tooManyMessage = _ref.tooManyMessage;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var typeErrors = types.map(function (type) {
      return type.apply(void 0, args);
    }).filter(function (error) {
      return error;
    });

    if (typeErrors.length === types.length) {
      // Everything errored
      return new Error(noMatchMessage);
    }

    if (types.length - typeErrors.length > 1) {
      // Too many types passed
      return new Error(tooManyMessage);
    }

    return undefined;
  };
};
/*
 * Example, `adId` is a valid proptype only if `adUrl` has a value
 *
   {
     adId: customPropType.alternate('adUrl', PropTypes.any.isRequired),
   }
 */

export var alternate = function alternate(alternatePropName, type, message) {
  return function (props, propName, displayName) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
      args[_key2 - 3] = arguments[_key2];
    }

    var typeError = type.apply(void 0, [props, alternatePropName, displayName].concat(args));

    if (typeError && message) {
      return new Error(message);
    }

    return typeError;
  };
};
/*
 * Example, for usage an AND
 *
   {
     adUrl: customPropType.every([
       PropTypes.string.isRequired,
       customPropType.alternate('inlineComponent', PropTypes.func.isRequired),
     ]),
   }
 */

export var every = function every(types, message) {
  return function () {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    var typeError;
    types.some(function (type) {
      typeError = type.apply(void 0, args);
      return typeError;
    });

    if (typeError && message) {
      return new Error(message);
    }

    return typeError;
  };
};